import {memo, Suspense} from 'react'
import {EntryPointContainer} from 'react-relay'
import type {PreloadedEntryPoint} from 'react-relay/relay-hooks/EntryPointTypes'

import StoredSettingsValueProvider from '../../contexts/StoredSettingsValue/StoredSettingsValueContext'
import type {pipelineHeadFragment$key} from '../../hooks/__generated__/pipelineHeadFragment.graphql'
import {useJobId} from '../EditPipelinePage.hooks'

import type {JobSettingsSidebarComponent} from './JobSettingsSidebar/JobSettingsSidebar'
import PipelineSettingsSidebar from './PipelineSettingsSidebar/PipelineSettingsSidebar'

import styles from './SettingsSidebarContent.css'

type Props = {
  pipelineHeadKey: pipelineHeadFragment$key | null
  jobSettingsSidebarEntryPoint?: PreloadedEntryPoint<JobSettingsSidebarComponent>
}
function SettingsSidebarContent({pipelineHeadKey, jobSettingsSidebarEntryPoint}: Props) {
  const selectedJob = useJobId()

  return (
    <StoredSettingsValueProvider>
      <div className={styles.content}>
        <Suspense>
          {selectedJob != null ? (
            jobSettingsSidebarEntryPoint != null && (
              <EntryPointContainer
                entryPointReference={jobSettingsSidebarEntryPoint}
                props={{pipelineHeadKey}}
              />
            )
          ) : (
            <PipelineSettingsSidebar />
          )}
        </Suspense>
      </div>
    </StoredSettingsValueProvider>
  )
}

export default memo(SettingsSidebarContent)
